import { translate } from "./localization";

export function translateEmployeeProperties(property, value) {
  const properties = {
    state: {
      active: translate("employees-section.active"),
      removed: translate("employees-section.removed"),
      blocked: translate("employees-section.blocked"),
      pending: translate("employees-section.pending"),
      uploading: translate("employees-section.uploading"),
      "not-active": translate("employees-section.not-active"),
      "pending-email-verification": translate(
        "employees-section.pending-email-verification"
      ),
    },
    taxRegime: {
      general: translate("employees-section.regime-general"),
      basque: translate("employees-section.regime-basque"),
      navarrese: translate("employees-section.regime-navarrese"),
      biscayan: translate("employees-section.regime-biscayan"),
    },
    errors: {
      "duplicated-email": translate("employees-section.duplicated-email"),
      "missing-gross-salary": translate(
        "employees-section.missing-gross-salary"
      ),
      "missing-name": translate("employees-section.missing-name"),
      "invalid-chars-in-name": translate(
        "employees-section.invalid-chars-in-name"
      ),
      "missing-surname": translate("employees-section.missing-surname"),
      "invalid-chars-in-surname": translate(
        "employees-section.invalid-chars-in-surname"
      ),
      "invalid-legal-id": translate("employees-section.invalid-legal-id"),
      "missing-email": translate("employees-section.missing-email"),
      "invalid-email": translate("employees-section.invalid-email"),
      "different-domain-email": translate(
        "employees-section.different-domain-email"
      ),
      "inefficient-gross-salary": translate(
        "employees-section.inefficient-gross-salary"
      ),
      "invalid-ascii-name": translate("employees-section.invalid-ascii-name"),
      "invalid-ascii-surname": translate(
        "employees-section.invalid-ascii-surname"
      ),
      "employee-not-found-in-session": translate(
        "employees-section.employee-not-found-in-session"
      ),
      "invalid-hiring-date": translate("employees-section.invalid-hiring-date"),
      "invalid-cost-center": translate("employees-section.invalid-cost-center"),
      "invalid-subsidiary": translate("employees-section.invalid-subsidiary"),
      "invalid-work-time-percentage": translate(
        "employees-section.invalid-work-time-percentage"
      ),
      "invalid-birth-date": translate("employees-section.invalid-birth-date"),
      "invalid-collective-agreement-salary": translate(
        "employees-section.invalid-collective-agreement-salary"
      ),
      "invalid-number-of-paychecks": translate(
        "employees-section.invalid-number-of-paychecks"
      ),
      "invalid-nationality": translate("employees-section.invalid-nationality"),
      "invalid-home-address": translate(
        "employees-section.invalid-home-address"
      ),
      "invalid-gender": translate("employees-section.invalid-gender"),
      "invalid-mobile-country-code": translate(
        "employees-section.invalid-mobile-country-code"
      ),
      "invalid-mobile-phone": translate(
        "employees-section.invalid-mobile-phone"
      ),
      "invalid-bank-account": translate(
        "employees-section.invalid-bank-account"
      ),
      "missing-mobile-country-code": translate(
        "employees-section.missing-mobile-country-code"
      ),
      "missing-mobile-phone": translate(
        "employees-section.missing-mobile-phone"
      ),
    },
  };

  if (!properties[property]?.[value]) {
    return value;
  }

  return properties[property][value];
}
